<template>
  <v-list
    v-if="userAssignServices !== null"
    class="py-0"
  >
    <template
      v-for="(v, index) in availableServices"
      :key="v.id"
    >
      <v-list-item
        class="py-0"
        density="compact"
      >
        <!-- service icon -->
        <template #prepend>
          <img
            :src="image(v.icon_file)"
            alt="service icon"
            :class="{'disable-opacity': v.enabled !== true}"
            style="height: 36px"
          >
        </template>

        <!-- service info -->
        <v-list-item-title
          :class="{'disable-opacity': v.enabled !== true}"
          class="ml-4"
        >
          {{ $t('Service.Brand.' + v.id) }}
        </v-list-item-title>
        <v-list-item-subtitle
          :class="{'disable-opacity': v.enabled !== true}"
          class="ml-4"
        >
          <a
            :href="v.service_url"
            target="_blank"
          >{{ v.service_url }}</a>
        </v-list-item-subtitle>

        <!-- toggles -->
        <template #append>
          <v-list-item-action v-if="is_admin">
            <v-switch
              v-model="v.enabled"
              color="secondary"
              :label="$vuetify.display.smAndUp ? getToggleLabel(v.enabled) : undefined"
              :class="{'text-secondary': v.enabled}"
              @change="changeAction()"
            />
          </v-list-item-action>
        </template>
      </v-list-item>
      <v-divider
        v-if="index + 1 < availableServices.length"
        :key="index"
      />
    </template>
    <div
      v-if="!availableServices[0]"
      class="my-3 mx-4 text-grey"
    >
      {{ $t('Service.NoServicesAvailableInOrganization') }}
    </div>
  </v-list>
  <v-list
    v-else
    class="pa-3"
  >
    ...
  </v-list>
</template>

<script>
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [ServiceIconMixin],
    props: {
      readOnly: Boolean,
      userId: {
        type: String,
        required: true
      }
    },
    data: () => ({
      availableServices: null,
      userAssignServices: null
    }),
    computed: {
      ...mapGetters(['login']),
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      }
    },
    created () {
      this.get()
    },
    methods: {
      get () {
        this.$http.get('available-services/', { params: { limit: 1000 } }).then(
          (res) => {
            this.availableServices = this.$filters.removeUnusedServices(res.data.results)
            this.$http.get(`user-assign-services/${this.userId}/`).then(
              (res2) => {
                this.userAssignServices = res2.data.services
                this.availableServices.forEach((v) => {
                  this.userAssignServices.forEach((x) => {
                    if (v.id === x) {
                      v['enabled'] = true
                    }
                  })
                })
              })
          })
      },
      changeAction () {
        if (this.is_admin) {
          let data = []
          for (let x of this.availableServices) {
            if (x['enabled']) {
              data.push(x.id)
            }
          }
          this.$http.put(`user-assign-services/${this.userId}/`,
            { services: data })
        }
      },
      getToggleLabel (enabled) {
        return enabled ? this.$t('Service.Usable') : this.$t('Service.Unusable')
      }
    }
  }
</script>

<style>
  .disable-opacity {
    opacity: .3;
  }
</style>
